function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 会議素材（データ）　モデル
 */
var UploadGroupMaterialsInstanceModel =
/**
 * コンストラクタ
 *
 */
function UploadGroupMaterialsInstanceModel() {
  _classCallCheck(this, UploadGroupMaterialsInstanceModel);

  this.SessionId = -1;
  this.MaterialFileName = "";
  this.DisplayFileName = "";
  this.Items = [];
};

export { UploadGroupMaterialsInstanceModel as default };